import React, { useContext, useState, useEffect } from "react";
import { Dialog, List, SwipeAction, Toast } from "antd-mobile";

import { Col, Form, Row } from "react-bootstrap";
import { Button } from "react-bootstrap";
import axios from "axios";

import PsContext from "../../context";
import { MOB_ICONS, momentDate, upperCase, S3_BUCKET_HOME_PATH, siteUrl } from "../../utils";
import Header from "../header";
import WelcomeProfile from "../home/welcomeProfile";
import ModuleAccess from "../../context/moduleAccess";

import AddConvocation from "./addconvocation";
import { ServiceUrl } from "../../utils/serviceUrl";
import toast from "react-hot-toast";
import { APP_TYPE, baseUrl } from "../../utils";
import PrintPdf from "./printpdf"
import PsModalWindow from "../../utils/PsModalWindow";

const Convocation = (props) => {
    const context = useContext(PsContext);
    const [showAdd, setShowAdd] = useState(false);
    const [profile, setProfile] = useState([]);
    const [viewData, setViewData] = useState([]);
    const [loader, setLoader] = useState([]);
    const [printReport, setPrintReport] = useState(false);

    const [timeTable, setTimeTable] = useState([]);


    const userPhoto = () => {
        let gender = upperCase(context.user.gender);
        if (gender == "MALE") return MOB_ICONS.MAN_256;
        else if (gender == "FEMALE") return MOB_ICONS.WOMAN_256;
    };

    useEffect(() => {
        loadData();
    }, []);




    const loadData = () => {
        setLoader(true);
        // setDataOption([]);
        const form = new FormData();
        axios
            .post(
                ServiceUrl.STUDENTS.LIST_CONVOCATION +
                "?" +
                "&registerno=" +
                context.user.registerno
            )
            .then((res) => {
                if (res["data"].status == "1") {
                    setViewData(res["data"].data);
                    console.log(res["data"].data);

                } else {
                    Toast.show({ content: res["data"].message || "Error" });
                }
                setLoader(false);
            });
    };


    // const downloadFile = () => {
    //     let link = `${baseUrl}mob/v1/pdf`;
    //     var a = document.createElement("a");
    //     a.setAttribute("download", viewData.registerno);
    //     a.setAttribute("href", link);
    //     document.body.appendChild(a);
    //     a.click();
    //     document.body.removeChild(a);
    // };

    const downloadFile = () => {
        let registrationNumber = viewData[0].registerno;
        let link = `${baseUrl}mob/v1/pdf?q=${registrationNumber}`;
        var a = document.createElement("a");
        a.setAttribute("download", registrationNumber);
        a.setAttribute("href", link);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };



    return (
        <>
            <Header title="Convocation" backAction={true} />
            <div className="page-content-wrapper">
                <div className="container py-2 px-0">
                    <WelcomeProfile />
                    <div className="bg-blue-100 text-primary fw-bold p-2 form-title-card">
                        <input
                            type="hidden"
                            name="registerno"
                            value={context.user.registerno}
                        />
                        <Row className="mt-3">
                            <Col md={8}>
                                Application For Convocation</Col>

                            <Col md={2}>
                                <li className="list-inline-item">
                                    {/* <Button
                                        size="sm"
                                        variant="primary"
                                        className="border-start fs-6"
                                        onClick={(e) => downloadFile()}
                                    //  onClick={(e) => setPrintReport(true)}
                                    //  disabled={student.length < 1}
                                    >
                                        <i className="fa-solid fa-file-arrow-down"></i>
                                    </Button> */}

                                    <Button

                                        to="route"
                                        onClick={(event) => {
                                            event.preventDefault();
                                            window.open(
                                                siteUrl +
                                                "files_list/" +
                                                S3_BUCKET_HOME_PATH +
                                                "convocation/" +
                                                viewData[0].uuid +
                                                ".pdf"
                                            );
                                        }}
                                    >

                                        <i className="fa fa-download fs-6"></i>

                                    </Button>
                                </li>
                            </Col>
                            <Col md={2}>
                                <Button
                                    size="sm"
                                    variant="primary"
                                    className="border-start fs-6"
                                    onClick={(e) => setShowAdd(true)}
                                >
                                    <i className="fa-solid fa-plus"></i>
                                </Button>

                            </Col>

                        </Row>

                    </div>


                    <div className="px-2">
                        <Row className="mt-2">
                            <Col md={4} sm={4} xs={4}>
                                <label>
                                    Name <span className="text-danger"></span>
                                </label>
                            </Col>
                            <Col md={8} sm={8} xs={8}>
                                <Form.Control
                                    type="text"
                                    size="sm"
                                    className="fw-bold"
                                    value={`${context.user.name} ${context.user.initial || ""}`}
                                />
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col md={4} sm={4} xs={4}>
                                <label>
                                    Gender <span className="text-danger"></span>
                                </label>
                            </Col>
                            <Col md={8} sm={8} xs={8}>
                                <Form.Control
                                    type="text"
                                    size="sm"
                                    className="fw-bold"
                                    value={upperCase(context.user.gender)}
                                />
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col md={4} sm={4} xs={4}>
                                <label>
                                    DOB <span className="text-danger"></span>
                                </label>
                            </Col>
                            <Col md={8} sm={8} xs={8}>
                                <Form.Control
                                    type="text"
                                    size="sm"
                                    className="fw-bold"
                                    value={momentDate(context.user.dob, "DD-MMM-YYYY")}
                                />
                            </Col>
                        </Row>

                    </div>
                </div>
            </div >
            <PsModalWindow
                size="md"
                show={showAdd}
                title="Application For Convocation"
                onHide={(e) => setShowAdd(false)}
            >
                <AddConvocation
                    dataSource={viewData}
                    onSuccess={(e) => {

                        setShowAdd(false);
                        loadData();

                    }}
                />
            </PsModalWindow>

            {
                printReport && (
                    <PrintPdf
                        dataSource={viewData}
                        //onSuccess={(e) => { }}
                        onSuccess={(e) => setPrintReport(false)}

                    />

                )
            }
        </>
    );
};
export default Convocation;
